import React, { useContext, useEffect, useRef, useState } from "react"
import DocumentMeta from "react-document-meta"
import { useNavigate } from "react-router-dom"
import gsap from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"
import Spinner from "../components/elements/Spinner"
import Form from "../components/Forms/FormHook"
import Sogehts from "../components/home/Sogehts"
import PromoSoonOverHandler from "../components/PromoSoonOverHandler"
import TextBook, { TextBookKeys } from "../components/Textbook"
import { getPromoLimit, getWeeklyLimit } from "../env"
import { Context } from "../store/store"
import ParticipationCounter from "../components/ParticipationCounter"
import ScrollParentToTop from "../components/ScrollParentToTop"

const Home: React.FC = () => {
	const { globalState } = useContext(Context)
	const biscoffBarRef = useRef<HTMLImageElement | null>(null)
	const normalBarRef = useRef<HTMLImageElement | null>(null)

	// SEO Meta Tags
	const [limitReached, setLimitReached] = useState<boolean>(false)
	const [isApiError, setApiError] = useState<boolean>(false)
	const navigate = useNavigate()

	const meta = {
		title: "Probiere jetzt deine TREK Protein Oat Bar",
		description: "Probiere jetzt deine TREK Protein Oat Bar. Kaufe eine TREK Protein Oat Bar, lade deinen Kassenbon hoch und bekomme den Kaufpreis zurück.",
		meta: {
			name: {
				robots: "noindex, nofollow",
			},
		},
	}
	async function getOrderLimits() {
		let maxLimit = await getWeeklyLimit()
		if (typeof maxLimit !== "boolean") {
			setApiError(true)
		} else {
			setLimitReached(maxLimit)

			let overallLimit = await getPromoLimit()
			console.log(overallLimit)
			if (overallLimit) {
				navigate("/promoover")
			}
		}
	}
	function scrollToHash(hash) {
		setTimeout(() => {
			try {
				const doc: any = document
				const { top } = doc.querySelector(hash).getBoundingClientRect()
				window.scrollTo({
					top: top + window.scrollY,
					left: 0,
					behavior: "smooth",
				})
			} catch (error) {}
		}, 700)
	}

	useEffect(() => {
		getOrderLimits()
		if (window.location.hash) {
			scrollToHash(window.location.hash)
		}
	}, [])

	useEffect(() => {
		if (!globalState.strapi.homepage) {
			return
		}

		gsap.registerPlugin(ScrollTrigger)
		const ctx = gsap.context(() => {
			const bars = [biscoffBarRef.current, normalBarRef.current].filter(Boolean) as HTMLImageElement[]

			bars.forEach((bar, index) => {
				gsap.fromTo(
					bar,
					{ autoAlpha: 0, y: 46, x: -14, rotate: index === 0 ? -5 : 5, scale: 0.95 },
					{
						autoAlpha: 1,
						y: 0,
						x: 0,
						rotate: 0,
						scale: 1,
						duration: 1.1,
						delay: index * 0.12,
						ease: "power3.out",
						scrollTrigger: {
							trigger: bar,
							start: "top 86%",
							toggleActions: "play none none reverse",
						},
					}
				)

				const floatTl = gsap.timeline({
					repeat: -1,
					yoyo: true,
					delay: 0.35 + index * 0.28,
					defaults: { ease: "sine.inOut" },
				})

				floatTl
					.to(bar, {
						y: index === 0 ? 11 : -11,
						x: index === 0 ? 6 : -6,
						rotate: index === 0 ? 1.6 : -1.6,
						scale: 1.018,
						duration: 2.5 + index * 0.3,
					})
					.to(bar, {
						y: index === 0 ? -7 : 7,
						x: index === 0 ? -3 : 3,
						rotate: index === 0 ? -1.05 : 1.05,
						scale: 0.996,
						duration: 2.05 + index * 0.25,
					})
			})
		})

		return () => {
			ctx.revert()
		}
	}, [globalState.strapi.homepage])
	return (
		<DocumentMeta {...meta}>
			<PromoSoonOverHandler>
				<>
					{!window.location.hash && <ScrollParentToTop />}
					{globalState.strapi.homepage ? (
						<>
							{/*<div className="relative bg-hero">
								<div className="grid md:grid-cols-2 items-center justify-items-center lg:h-[667px] max-w-[1324px] mx-auto">
									<div className="relative sm:hidden bg-[url('/src/bgimages/header-hero-mobile.png')] bg-no-repeat w-full bg-center bg-cover h-[300px] ">
										<img src={process.env.PUBLIC_URL + "/images/header-mobile.png"} alt="TREK Protein Oat Bar" className="mx-auto block sm:hidden" />
									</div>
									<div className="w-full lg:max-w-[100%] mx-auto px-4  pb-12 md:p-12 relative z-[5]">
										<h1 className=" text-white uppercase pt-12">Jetzt probieren - ganz ohne Risiko.</h1>
										<p className="text-white lg:max-w-[90%] font-AmsiRegular">Vom 01. September bis 31. Dezember bekommst du Dein Geld für eine Packung TREK Protein Oat Bars 150g zurück.</p>
										<div className=" grid grid-cols-2 md:flex  items-center gap-x-2 md:gap-x-6 mt-6 lg:mt-12 ">
											<a href="#form-content" className="btn btn-primary justify-self-center">
												Jetzt teilnehmen
											</a>
											<a href="#sogehts" className="btn btn-secondary justify-self-center">
												mehr erfahren
											</a>
										</div>
									</div>
									<div className="relative bg-[url('/src/bgimages/bg-hero-right.png')] bg-no-repeat w-full bg-center bg-cover h-[300px] md:h-[667px] before-hero hidden md:block">
									<img src={process.env.PUBLIC_URL + "/images/cashback-hero.png"} alt="Cashback Geld-zurück-Siegel" className="mx-auto hidden md:block absolute -left-16 h-[40%] top-44" />
										<img ref={biscoffBarRef} src={process.env.PUBLIC_URL + "/images/trek-biscoff-riegel.png"} alt="TREK Protein Oat Bar Biscoff" className="mx-auto hidden md:block absolute left-32" />
										<img ref={normalBarRef} src={process.env.PUBLIC_URL + "/images/trek-normal-riegel.png"} alt="TREK Protein Oat Bar" className="mx-auto hidden md:block absolute bottom-4 left-32" />
									</div>
								</div>
							</div> */}
							<div id="sogehts">
								<Sogehts />
							</div>
							<div className="bg-bottom-divider-count bg-white bg-[url('/src/bgimages/bg-divider-desktop.png')] bg-no-repeat w-full bg-center bg-cover h-[100px] md:h-[300px]"></div>
						<ParticipationCounter/>
						<div className="bg-bottom-divier bg-white bg-[url('/src/bgimages/bg-divider-desktop-bottom.png')] bg-no-repeat w-full bg-center bg-cover h-[100px] md:h-[300px]"></div>
							{isApiError ? (
								<>
									<div className="mt-12 lg:mt-24">
										<h2>
											Leider ist ein Fehler aufgetreten. <br />
											Bitte versuche es später erneut.
										</h2>
									</div>
								</>
							) : !limitReached ? (
								<>
									<Form />
									
								</>
							) : (
								<>
									<div className="mt-12 lg:mt-24">
										<h2 className=" mb-12 text-center font-Veener text-[28px] uppercase text-red lg:text-[58px]">
											Diese Woche sind leider keine Erstattungen mehr möglich. <br />
											Bitte versuche es ab nächsten Montag erneut.
										</h2>
									</div>
								</>
							)}
						</>
					) : (
						<div className="py-20 text-center">
							<Spinner />
							<TextBook textKey={TextBookKeys.HOMEPAGE} />
						</div>
					)}
				</>
			</PromoSoonOverHandler>
		</DocumentMeta>
	)
}
export default Home
